/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleSearchModel } from '../../models/article-search-model';
import { SearchResultModel } from '../../models/search-result-model';

export interface SearchClientIdPost$Json$Params {
  clientId: string;
      body?: ArticleSearchModel
}

export function searchClientIdPost$Json(http: HttpClient, rootUrl: string, params: SearchClientIdPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<SearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, searchClientIdPost$Json.PATH, 'post');
  if (params) {
    rb.path('clientId', params.clientId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<SearchResultModel>>;
    })
  );
}

searchClientIdPost$Json.PATH = '/Search/{clientId}';
